// @flow
export { default } from './QuoteComment';



// WEBPACK FOOTER //
// ./src/components/quote/QuoteComment/index.js